import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  FaApple,
  FaBolt,
  FaBus,
  FaBuilding,
  FaCarSide,
  FaGooglePlay,
  FaHandshake,
  FaLocationDot,
  FaMapLocationDot,
  FaMapPin,
  FaMotorcycle,
  FaRobot,
  FaRoute,
  FaShieldHalved,
  FaStore,
  FaTrophy,
  FaUsers,
  FaUtensils,
} from "react-icons/fa6";
import "../AllRider/allRider.css";
import "../style01.css";
import "../style02.css";
import "../AllMetuaaEat/metuaaEat.css";
import "../AllMetuaa/metuaa.css";
import "./metuaaTravelHub.css";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import bus1 from "../../../assets/images/baniere travel hub.png";
import bus2 from "../../../assets/images/baniere travel hub.png";
import mapperImage from "../../../assets/images/image-mapper.png";
import eatImage from "../../../assets/images/metuaa-eat.png";
import travelImage from "../../../assets/images/card1.png";
import travelImagefirst from "../../../assets/images/card2.png";
import travelImagesecond from "../../../assets/images/card3.png";
import driverImage from "../../../assets/images/all-slider/driver-slide-cameroon.png";
import enterpriseImage from "../../../assets/images/all-slider/image-entreprise.png";
import mplusImage from "../../../assets/images/New-2025-Kia-Carnival-6.avif";
import phoneImage from "../../../assets/images/card4.png";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";

const heroTransitionTypes = ["fade", "slide-left", "slide-right", "square"];

const travelSlides = [
  {
    src: bus1,
    alt: "Bus Metua'a Travel Hub sur la route interurbaine",
    title1Id: "travel.slide1.title1",
    title2Id: "travel.slide1.title2",
    descriptionId: "travel.slide1.description",
  },
  {
    src: bus2,
    alt: "Voyageurs à bord d'un bus Metua'a Travel Hub",
    title1Id: "travel.slide2.title1",
    title2Id: "travel.slide2.title2",
    descriptionId: "travel.slide2.description",
  },
];

const travelFilters = [
  { id: "all", label: "travel.categories.all", icon: FaRoute },
  { id: "urban", label: "travel.categories.urban", icon: FaCarSide },
  { id: "interurban", label: "travel.categories.interurban", icon: FaBus },
  { id: "covoiturage", label: "travel.categories.covoiturage", icon: FaUsers },
  { id: "companies", label: "travel.categories.companies", icon: FaBuilding },
];

export const services = [
  {
    key: "mapper",
    image: mapperImage,
    icon: FaMapPin,
    title: "Metua'a Mappers",
    text: "Numérisez votre quartier, validez des lieux et gagnez de l'argent en aidant la communauté à mieux se déplacer.",
    href: "/metuaa-mapper",
  },
  {
    key: "eat",
    image: eatImage,
    icon: FaUtensils,
    title: "Metua'a Eats",
    text: "Commandez vos plats préférés et faites-vous livrer à domicile ou au bureau, en toute fraîcheur.",
    href: "/metuaa-eat",
  },
  {
    key: "travel",
    image: travelImage,
    icon: FaBus,
    title: "Metua'a Travel Hub",
    text: "Covoiturage et voyages interurbains : réservez votre place auprès des compagnies de transport.",
    href: "/metuaa-travel-hub",
  },
  {
    key: "driver",
    image: driverImage,
    icon: FaMotorcycle,
    title: "Conduire avec Metua'a",
    text: "Soyez votre propre patron. Gagnez de l'argent en conduisant quand vous voulez.",
    href: "/all-driver",
  },
  {
    key: "enterprise",
    image: enterpriseImage,
    icon: FaHandshake,
    title: "Metua'a Entreprise",
    text: "Simplifiez les déplacements de vos collaborateurs et gérez vos opérations avec des outils sécurisés.",
    href: "/all-enterprise",
  },
  {
    key: "mplus",
    image: mplusImage,
    icon: FaCarSide,
    title: "Programme M+",
    text: "Acquérez votre propre véhicule grâce au programme M+ et maximisez vos revenus quotidiens.",
    href: "/mplus-program",
  },
];

// const howItWorksSteps = [
//   {
//     key: "choose",
//     icon: FaStore,
//     title: "Choisissez votre service",
//     text: "Course, repas, trajet interurbain ou mission de cartographie : sélectionnez le service Metua'a dont vous avez besoin.",
//   },
//   {
//     key: "request",
//     icon: FaLocationDot,
//     title: "Faites votre demande",
//     text: "Indiquez votre position et votre destination. Nous vous connectons au bon partenaire, en temps réel.",
//   },
//   {
//     key: "ride",
//     icon: FaBolt,
//     title: "Profitez de l'écosystème",
//     text: "Suivez votre course ou votre livraison, payez en toute sécurité et profitez des avantages Metua'a.",
//   },
// ];

export const featureCards = [
  {
    key: "africa",
    icon: FaUsers,
    title: "Pour les voyageurs",
    text: "Recherchez un trajet, comparez les offres, réservez et payez votre billet en ligne en toute sécurité. Suivez également votre voyage en temps réel grâce au système de tracking intégré.",
  },
  {
    key: "secure",
    icon: FaShieldHalved,
    title: "Pour les compagnies de transport",
    text: "Digitalisez vos opérations en gérant votre flotte, vos chauffeurs, vos itinéraires et vos réservations depuis une interface unique. Optimisez vos capacités de transport et améliorez votre efficacité opérationnelle.",
  },
  {
    key: "allinone",
    icon: FaRobot,
    title: "Une mobilité plus sûre et plus intelligente",
    text: "Chaque compagnie partenaire est vérifiée avant son intégration à la plateforme, garantissant un service fiable et sécurisé.",
  },
  {
    key: "rewards",
    icon: FaTrophy,
    title: "Récompenses Metua'a",
    text: "Programme de fidélité et bonus : chaque course et chaque mission vous rapporte des avantages exclusifs.",
  },
];

function ChevronLeftIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
    </svg>
  );
}

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

export default function AllMetuaaTravelHub() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPrevIndex, setHeroPrevIndex] = useState(0);
  const [heroTransition, setHeroTransition] = useState("fade");
  const [isHeroPaused, setIsHeroPaused] = useState(false);
  const [activeTravelFilter, setActiveTravelFilter] = useState("all");
  const heroTimerRef = useRef(null);

  const goToHeroSlide = (updater) => {
    const type = heroTransitionTypes[Math.floor(Math.random() * heroTransitionTypes.length)];
    setHeroTransition(type);
    setHeroIndex(updater);
  };

  useEffect(() => {
    if (isHeroPaused || travelSlides.length <= 1) return;
    heroTimerRef.current = setInterval(() => {
      goToHeroSlide((prev) => (prev + 1) % travelSlides.length);
    }, 5000);
    return () => clearInterval(heroTimerRef.current);
  }, [isHeroPaused]);

  useEffect(() => {
    if (heroPrevIndex === heroIndex) return;
    const id = setTimeout(() => setHeroPrevIndex(heroIndex), 900);
    return () => clearTimeout(id);
  }, [heroIndex, heroPrevIndex]);

  const hasMultipleSlides = travelSlides.length > 1;

  return (
    <div id="__next">
      <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">
        <Header />

        <main className="metuaa-travel-hub-page">

          {/* ══════════════════ HERO SLIDE ══════════════════ */}
          <section
            data-testid="travel-hero-slider"
            className="eats-slider travel-slider"
            onMouseEnter={() => setIsHeroPaused(true)}
            onMouseLeave={() => setIsHeroPaused(false)}
          >
            <img src={travelSlides[heroPrevIndex].src} alt={travelSlides[heroPrevIndex].alt} className="eats-slider__layer" />

            {heroIndex !== heroPrevIndex && (
              <img
                key={heroIndex}
                src={travelSlides[heroIndex]?.src}
                alt={travelSlides[heroIndex]?.alt}
                className={`eats-slider__layer eats-slider__anim hero-anim-${heroTransition}`}
              />
            )}

            <div className="eats-slider__overlay" aria-hidden="true" />

            <div className="eats-slider__content">
              <div key={heroIndex} className={`hero-slide-anim hero-anim-${heroTransition}`}>
                <h1 className="eats-slider__title">
                  {t(travelSlides[heroIndex]?.title1Id)}{" "}
                  <span>{t(travelSlides[heroIndex]?.title2Id)}</span>
                </h1>
                <p className="eats-slider__desc">{t(travelSlides[heroIndex]?.descriptionId)}</p>
                <div className="eats-slider__search">
                  <span className="eats-slider__search-icon">
                    <FaLocationDot />
                  </span>
                  <input type="text" placeholder={t("travel.search.placeholder")} />
                  <button type="button">{t("travel.search.button")}</button>
                </div>
                <div className="hero-btn-group">
                  <a href="/signup-passenger" className="eats-slider__cta eats-slider__cta--outline">
                    {t("travel.slide1.cta.book")}
                  </a>
                  <a href="#partners" className="btn-secondary-outline">
                    {t("travel.slide1.cta.partner")}
                  </a>
                </div>
              </div>
            </div>

            {hasMultipleSlides && (
              <>
                <button
                  type="button"
                  className="eats-slider__arrow eats-slider__arrow--prev"
                  aria-label={t("travel.slide.prev")}
                  onClick={() => goToHeroSlide((prev) => (prev - 1 + travelSlides.length) % travelSlides.length)}
                >
                  <ChevronLeftIcon />
                </button>
                <button
                  type="button"
                  className="eats-slider__arrow eats-slider__arrow--next"
                  aria-label={t("travel.slide.next")}
                  onClick={() => goToHeroSlide((prev) => (prev + 1) % travelSlides.length)}
                >
                  <ChevronRightIcon />
                </button>
                <div className="eats-slider__dots">
                  {travelSlides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      aria-label={t("travel.slide.dot", { index: i + 1 })}
                      className={`eats-slider__dot${i === heroIndex ? " is-active" : ""}`}
                      onClick={() => goToHeroSlide(() => i)}
                    />
                  ))}
                </div>
              </>
            )}
          </section>

          {/* ══════════════════ CATEGORIES ══════════════════ */}
          <section className="food-filters-section" aria-label="Catégories de trajets">
            <div className="filters-scroll">
              {travelFilters.map(({ id, label, icon: Icon }) => (
                <button
                  key={id}
                  type="button"
                  className={`filter-chip${activeTravelFilter === id ? " active" : ""}`}
                  aria-pressed={activeTravelFilter === id}
                  onClick={() => setActiveTravelFilter(id)}
                >
                  <Icon aria-hidden="true" />
                  {t(label)}
                </button>
              ))}
            </div>
          </section>

          {/* ══════════════════ AGENCES DE VOYAGES ══════════════════ */}
          <section className="travel-agencies-section">
            <div className="page-shell">
              <div className="travel-agencies-header">
                <span className="travel-agencies-icon" aria-hidden="true">
                  <FaBus />
                </span>
                <h1 className="travel-agencies-title">METUA'A TRAVEL HUB</h1>
              </div>

              <p className="travel-agencies-subtitle">
                La plateforme digitale qui connecte les agences de voyages et les voyageurs afin de simplifier la recherche, la réservation et l'organisation des déplacements.
              </p>

              <div className="travel-agencies-grid">
                <article className="travel-agency-card">
                  <div className="travel-agency-body">
                    <h3 className="travel-agency-title">LES AGENCES DE VOYAGES PUBIENT LES VOYAGES</h3>
                    <p className="travel-agency-text">
                       Les agences créant et publient leurs programmes de voyages (itinéraires, horaires, tarifs, capacités).
                    </p>
                  </div>
                  <img
                    src={travelImage}
                    className="travel-agency-image"
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                </article>
                <article className="travel-agency-card">
                  <div className="travel-agency-body">
                    <h3 className="travel-agency-title">LES PASSAGERS RÉSERVENT ET PAIENT LES VOYAGES</h3>
                    <p className="travel-agency-text">
                   Les passagers recherchent leurs trajets, réservent leur place et effectuent le paiement en ligne.
                   </p>
                  </div>
                  <img
                    src={travelImagefirst}
                    className="travel-agency-image"
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                </article>
                <article className="travel-agency-card">
                  <div className="travel-agency-body">
                    <h3 className="travel-agency-title">LES DEUX SUIVENT LE VOYAGE EN TEMPS RÉEL</h3>
                    <p className="travel-agency-text">
                      Agences et passagers suivent le trajet en temps réel jusqu'a l'arrivée à destination 
                    </p>
                  </div>
                  <img
                    src={travelImagesecond}
                    className="travel-agency-image"
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                </article>
              </div>
            </div>
          </section>

          {/* ══════════════════ SERVICES ══════════════════ */}
          <section className="metuaa-services-section">
            <div className="page-shell">
              <h2 className="metuaa-services-title">
                Un écosystème, <mark>tous vos services</mark>
              </h2>
              <p className="metuaa-services-subtitle">
                Découvrez les services Metua'a et choisissez celui qui vous ressemble.
              </p>
              <div className="metuaa-services-grid">
                {services.map((service) => (
                  <a key={service.key} href={service.href} className="metuaa-service-card">
                    <div className="metuaa-service-image">
                      <img src={service.image} alt={service.title} loading="lazy" decoding="async" />
                    </div>
                    <div className="metuaa-service-body">
                      <span className="metuaa-service-icon" aria-hidden="true">
                        <service.icon />
                      </span>
                      <h3>{service.title}</h3>
                      <p>{service.text}</p>
                      <span className="metuaa-service-link">
                        Découvrir <FaMapLocationDot aria-hidden="true" />
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ HOW IT WORKS ══════════════════ */}
          {/* <section className="how-it-works-section" data-qa="how-it-works-section">
            <div className="how-it-works-content">
              <h3 className="how-it-works-eyebrow">Comment ça marche ?</h3>
              <h2 className="how-it-works-title">Simple et rapide !</h2>
              <div className="how-it-works-grid">
                {howItWorksSteps.map((step) => (
                  <article key={step.key} className="how-it-works-card">
                    <step.icon aria-hidden="true" className="how-it-works-icon" />
                    <h5 className="how-it-works-card-title">{step.title}</h5>
                    <p className="how-it-works-card-text">{step.text}</p>
                  </article>
                ))}
              </div>
            </div>
          </section> */}

          {/* ══════════════════ FEATURE CARDS ══════════════════ */}
          <section className="feature-cards-section">
            <div className="page-shell">
              <h2 className="feature-cards-title">Pourquoi choisir Metua'a ?</h2>
              <div className="feature-cards-grid">
                {featureCards.map((card) => (
                  <article key={card.key} className="feature-card">
                    <card.icon aria-hidden="true" className="feature-card-icon" />
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ OFFERS ══════════════════ */}
          <section
            className="all-page-section sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
            data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
            data-tracking-action="view"
            data-tracking-category="TextImageModule"
          >
            <div className="sc-eNSrOW kusvag">
              <div
                className="sc-satoz iYojpr"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "24px",
                  width: "100%",
                }}
              >
                {/* Colonne 1 : Card Package Famille */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_1})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.family.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.family.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button className="cardOffer-button">
                        {t("home.offers.discover")}
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Colonne 2 : Card Package Entreprise */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_2})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.business.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.business.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button type="button" className="cardOffer-button">
                        <span>{t("home.offers.discover")}</span>
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ══════════════════ DOWNLOAD APP ══════════════════ */}
          <section className="download-app-section" data-qa="download-app-section">
            <div className="page-shell">
              <div className="download-app-layout">
                <div className="download-app-info">
                  <h3 className="download-app-title">Téléchargez l'application</h3>
                  <p className="download-app-subtitle">Tous les services Metua'a, où que vous soyez !</p>
                  <div className="download-app-stores">
                    <a className="store-badge" href="#" aria-label="Accéder à iOS App Store" data-qa="download-app-section-ios-link">
                      <FaApple aria-hidden="true" />
                      <span>App Store</span>
                    </a>
                    <a className="store-badge" href="#" aria-label="Accéder à Google Play Store" data-qa="download-app-section-android-link">
                      <FaGooglePlay aria-hidden="true" />
                      <span>Google Play</span>
                    </a>
                  </div>
                </div>
                <div className="download-app-visual">
                  <img src={phoneImage} alt="Aperçu de l'application Metua'a" loading="lazy" decoding="async" />
                </div>
              </div>
            </div>
          </section>

        </main>

        <Footer />
      </span>
    </div>
  );
}
